import { render } from "./ResetButton.vue?vue&type=template&id=8149e788"
import script from "./ResetButton.vue?vue&type=script&lang=js"
export * from "./ResetButton.vue?vue&type=script&lang=js"

import "./ResetButton.vue?vue&type=style&index=0&id=8149e788&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__